/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { RoleByUserRes } from '../../models/role-by-user-res';

export interface ApiRoleCheckRoleByUserPost$Params {
  accountId?: string;
}

export function apiRoleCheckRoleByUserPost(http: HttpClient, rootUrl: string, params?: ApiRoleCheckRoleByUserPost$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<RoleByUserRes>>> {
  const rb = new RequestBuilder(rootUrl, apiRoleCheckRoleByUserPost.PATH, 'post');
  if (params) {
    rb.query('accountId', params.accountId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<RoleByUserRes>>;
    })
  );
}

apiRoleCheckRoleByUserPost.PATH = '/api/role/check-role-by-user';
